<div class="timeline-holder left">
    <div class="content">
      <h2>August-2020</h2>
      <p>Mobile Version Releases on Google Store</p>
    </div>
  </div>
